module.exports = __webpack_public_path__ + "img/icon_040623.d11fa778.svg";